import { useLocationBlockedPhrases } from "@casino/client/context/LocationBlockedPhrases/LocationBlockedPhrasesContext";
import ControlsClose from "@casino/external/icons/ControlsClose";
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  ErrorIcon,
} from "@workspace/frontend-ui";
import { createPortal } from "react-dom";

const ENGLISH_TITLE = "Location not supported";
const ENGLISH_DESCRIPTION =
  "Our services are unavailable from your current location. If you’re on a VPN, try turning it off and giving it another go!";

type Props = {
  onClose: () => void;
};

const LocationBlockedToast: FC<Props> = ({ onClose }) => {
  const { title = ENGLISH_TITLE, description = ENGLISH_DESCRIPTION } =
    useLocationBlockedPhrases();
  const closeLabel = useTranslation("general.close");

  return createPortal(
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-[999] flex justify-center md:inset-x-10 md:bottom-10 md:justify-start">
      <Alert
        variant="destructive"
        className="pointer-events-auto flex w-full min-w-[280px] max-w-[460px] items-start gap-3 p-4 shadow-xl min-[480px]:w-[80vw]"
      >
        <ErrorIcon />
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <AlertTitle>{title}</AlertTitle>
          <AlertDescription className="text-pretty">
            {description}
          </AlertDescription>
        </div>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={closeLabel}
          className="text-muted-foreground"
          onClick={onClose}
        >
          <ControlsClose />
        </Button>
      </Alert>
    </div>,
    document.body,
  );
};

export default LocationBlockedToast;
